export const CONTENT_OFFSET = {
    CONTENT_FOLDER_ID_OFFSET: 10007,
    CONTENT_INFO_ID_OFFSET: 19997,
    PUBLISHING_PLAN_ID_OFFSET: 15017,
}
